<app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categories" [label]="themeOptions.optionsConfiguration[optionType].label" [information]="themeOptions.options('doughnut').cutoutPercentage + '%'" [limitedTo]="themeOptions.limitedTo(optionType)">
  <div app-theme-option-content>
    <app-slider [color]="color" [value]="themeOptions.options('doughnut').cutoutPercentage" (sendValue)="receiveValue($event)"></app-slider>
  </div>
</app-theme-option>